import { principes } from '@/content/about';

/** Les trois règles, numérotées sur pastille ciel : accueil et À propos. */
export function Principes() {
  return (
    <div className="grid gap-7 desk:grid-cols-3 desk:gap-12">
      {principes.map((principe) => (
        <div key={principe.num}>
          <span className="rounded-xs bg-ciel px-2 py-[5px] text-num font-medium tabular-nums">
            {principe.num}
          </span>
          <h3 className="mt-4 mb-2.5 text-h3">{principe.title}</h3>
          <p className="text-encre-soft">{principe.body}</p>
        </div>
      ))}
    </div>
  );
}
